/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespSimilarItemsFooter_similarGridItems$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespContainer_similarGridItems$ref: FragmentReference;
export type PdpRespContainer_similarGridItems = {|
  +$fragmentRefs: PdpRespSimilarItemsFooter_similarGridItems$ref,
  +$refType: PdpRespContainer_similarGridItems$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespContainer_similarGridItems",
  "type": "moreLikeThisConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsFooter_similarGridItems",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '9592948420bef0dc097ca93ed76bec16';
module.exports = node;
